<template>
  <vx-card no-shadow>
    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      id="account-manage-buttons1"
    >
      <!-- Img Row -->
      <!-- <div class="flex flex-wrap items-center mb-base">
      <div class="vx-col" id="avatar-col">
        <div class="img-container mb-4">
          <img :src="this.$store.state.user.id_card_photo" class="rounded w-full" />
        </div>
      </div>
      </div>-->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="Name"
            class="w-full"
            v-model="name"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Phone</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="phone"
            class="w-full"
            v-model="phone"
          />
          <span class="text-danger text-sm" v-show="errors.has('phone')">{{
            errors.first("phone")
          }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Province</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="province"
              label="province"
              item-value="id"
              :options="provinces"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Kota</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="city"
              label="city_name"
              item-value="id"
              :options="cities"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Kecamatan</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <template>
            <v-select
              v-model="district"
              label="subdistrict_name"
              item-value="id"
              :options="districts"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </template>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Addres Detail</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="Addres Detail"
            class="w-full"
            v-model="detail_address"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Addres Detail')"
            >{{ errors.first("Addres Detail") }}</span
          >
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Logo</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <span class="text-normal text-sm"
            >Photo size 720px x 720px and max file size 1MB</span
          >
          <vs-input
            class="w-full"
            type="file"
            id="filexx"
            name="Photo"
            accept="image/x-png, image/jpeg, image/jpg"
            @change="onFileSelected"
          />
          <br />
          <img
            :src="this.$store.state.company.photo"
            class="rounded"
            width="200"
          />
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" button="submit">Save Changes</vs-button>
      </div>
    </form>
  </vx-card>
</template>

<script>
import axios from '../../../axios'
import axios120 from '../../../axios120'
import vSelect from 'vue-select'
export default {
  data() {
    return {
      provinces: [],
      userAuth: this.$store.state.user,
      name: this.$store.state.company.name,
      phone: this.$store.state.company.no_wa,
      province: { 'province': this.$store.state.company.address.province_name, 'province_id': this.$store.state.company.address.province_id },
      provinces: [],
      city: { 'city_name': this.$store.state.company.address.city_name, 'city_id': this.$store.state.company.address.city_id },
      cities: [],
      district: { 'subdistrict_name': this.$store.state.company.address.district_name, 'subdistrict_id': this.$store.state.company.address.district_id },
      districts: [],
      detail_address: this.$store.state.company.address.detail_address,
      photo: null,
      photos: []
    }
  },
  mounted() {
    this.getUser(this.userAuth.id)
    this.getProvince(1)
    this.getCity(1)
    this.getSubdistrict(1)
  },
  watch: {
    province(newValue, oldValue) {

      if (newValue.province_id != oldValue.province_id) {
        this.getCity(0)
      }


    },
    city(newValue, oldValue) {
      if (newValue.city_id != oldValue.city_id) {
        this.getSubdistrict(0)
      }

    },
  },
  methods: {
    onFileSelected(event) {
      this.photo = event.target.files[0]
    },
    onMultipleFileSelected(event) {

      console.log('lala')
      for (var i = 0; i < event.target.files.length; i++) {
        this.photos[i] = event.target.files[i];

      }
    },
    onSubmit() {
      var formData = new FormData();
      if (this.photo) {
        formData.append('photo', this.photo, this.photo.name)
      }
      // if (this.photos) {
      //   for (var i = 0; i < this.photos.length; i++) {
      //     formData.append('photos[' + i + ']', this.photos[i])

      //   }

      // }
      formData.append('id', this.userAuth.company.id)
      formData.append('name', this.name)
      formData.append('province_name', this.province.province)
      formData.append('province_id', this.province.province_id)
      formData.append('city_name', this.city.city_name)
      formData.append('city_id', this.city.city_id)
      formData.append('district_name', this.district.subdistrict_name)
      formData.append('district_id', this.district.subdistrict_id)
      formData.append('no_wa', this.phone)
      formData.append('detail_address', this.detail_address)
      this.$validator.validateAll().then(result => {
        if (result) {

          axios.post('ecommerce/web/store/update', formData)
            .then(res => {
              if (res.status != 200) {

                this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
              } else {


                this.acceptAlert('success', 'Berhasil', 'Anda berhasil edit company')
                this.$store.dispatch('updateCompany', res.data)

              }


            })
            .catch(error => {
              console.log(error.response)

            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')

        }
      })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },
    getUser(id) {
      axios120.post('ecommerce/web/auth/profile', {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            var store = res.data.store
            this.name = store.name
            this.phone = store.no_wa
            this.province = { 'province': store.address.province_name, 'province_id': store.address.province_id }
            this.city = { 'city_name': store.address.city_name, 'city_id': store.address.city_id }
            this.district = { 'subdistrict_name': store.address.district_name, 'subdistrict_id': store.address.district_id }

          }


        })
        .catch(error => {
          console.log(error.response)

        })
    },
    getProvince(firstTime) {
      axios.get('ecommerce/web/shipment/province', {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            this.provinces = res.data

          }


        })
        .catch(error => {
          console.log(error.response)

        })
    },
    getCity(firstTime) {
      axios.get('ecommerce/web/shipment/city/' + this.province.province_id, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {
            this.cities = res.data
            if (!firstTime) {
              this.city = { 'city_name': this.cities[0].city_name, 'city_id': this.cities[0].city_id }
            }
          }


        })
        .catch(error => {
          console.log(error.response)

        })
    },
    getSubdistrict(firstTime) {
      axios.get('ecommerce/web/shipment/subdistrict/' + this.city.city_id, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
          } else {

            this.districts = res.data
            if (!firstTime) {
              this.district = { 'subdistrict_name': this.districts[0].subdistrict_name, 'subdistrict_id': this.districts[0].subdistrict_id }

            }
          }


        })
        .catch(error => {
          console.log(error.response)

        })

    }

  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  components: {
    'v-select': vSelect,
  },
}
</script>
